import { Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core"
import { Router } from "@angular/router"
import { MatTabsModule } from "@angular/material/tabs"
import { MatButtonModule } from "@angular/material/button"

@Component({
    selector: "valben-header",
    templateUrl: "./header.component.html",
    styleUrls: ["./header.component.css"],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [MatTabsModule, MatButtonModule],
})
export class HeaderComponent {
    @Input() contentType!: number
    @Input() editEnabled!: boolean
    @Input() hideAddButton: boolean = false
    @Input() showContentTabs: boolean = true
    @Input() isKngPage: boolean = false
    @Input() isApprovedPage: boolean = false
    @Input() showUploadSignedContractsButton: boolean = false
    @Input() showKngNavigationButtons: boolean = true
    @Input() kngSuperiorSubmitBadgeCount?: number
    @Input() kngCommissionReviewBadgeCount?: number
    @Input() kngContractGenerationBadgeCount?: number
    @Input() kngUploadSignedContractsBadgeCount?: number
    /**
     * Section root ("/awards", "/categories", ...). Set it and the header navigates on tab click;
     * leave it unset and the header only emits, for the pages that swap content in place with
     * ngSwitch and have no add/edit routes to redirect to (KNG, average-monthly-income).
     */
    @Input() basePath?: string
    @Output() contentTypeChange = new EventEmitter<string>()

    constructor(private _router: Router) { }

    setContentType(value: string) {
        if (!this.basePath) {
            this.contentTypeChange.emit(value)
            return
        }

        // Edit has no target without a masterId, so in routed mode that tab is an indicator only —
        // it is enabled solely when the edit route is already active.
        if (value === "Search") this._router.navigateByUrl(this.basePath)
        if (value === "Add") this._router.navigateByUrl(`${this.basePath}/add`)
    }

    goToSubmitted(): void {
        this._router.navigate(["/kng-submitted"])
    }

    goToCommission(): void {
        this._router.navigate(["/kng-commission"])
    }

    goToContractGeneration(): void {
        this._router.navigate(["/kng-generate"])
    }

    goToUploadSignedContracts(): void {
        this._router.navigate(["/kng-upload-contracts"])
    }
}
